<template>
  <v-row justify="center" class="d-flex flex-row">
    <v-card
      class="ma-2 rounded-xl"
      max-width="300"
      v-for="skill in skills"
      :key="skill.name"
    >
      <v-card-text>
        <v-container>
          <v-row justify="center" class="d-flex flex-row text-no-wrap">
            <v-col cols="5" class="text-center">
              <p class="text-h5 text--primary">
                {{ skill.name }}
              </p>
              <p>経験年数：{{ skill.years }}年</p>
            </v-col>
            <v-img
              max-height="100"
              max-width="100"
              :src="skill.src"
              class="mx-auto"
              contain
            ></v-img>
          </v-row>
          <v-row class="my-2">
            <v-divider></v-divider>
          </v-row>
          <v-row justify="center" class="d-flex flex-row mt-5">
            <v-rating
              background-color="gray lighten-3"
              color="gray"
              large
              half-increments
              readonly
              length="5"
              :value="skill.value"
            ></v-rating>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="primary accent-4" @click="skill.judge = true">
          詳細はこちら
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <v-card
          v-if="skill.judge"
          class="transition-fast-in-fast-out v-card--reveal"
          style="height: 100%"
        >
          <v-card-text class="pb-0">
            <p class="text-h4 text--primary">{{ skill.name }}</p>

            <p class="no-wrap mb-0">{{ skill.detail }}</p>
          </v-card-text>
          <v-card-actions class="d-flex align-content-end flex-wrap pa-0">
            <v-btn text color="primary accent-4 pa-0" @click="skill.judge = false">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expand-transition>
    </v-card>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    skills: [
      {
        name: "Python",
        years: "6",
        value: "4.5",
        judge: false,
        src: require("@/assets/img/lang/Python.png"),
        detail: '大学の卒業研究ではnumpy,Pandas,matplotlib,Seabornによる数学の可視化を行った。\n・ウェブスクレイピング\n・ブラウザ・エクセルなどの自動化\n・pygameによるゲーム制作など\n様々な経験値あり',
      },
      {
        name: "HTML",
        years: "6",
        value: "4.5",
        judge: false,
        src: require("@/assets/img/lang/HTML.png"),
        detail: '大学の授業でHTML5を用いたLPの作成を経験。就職後会社の研修でプログラミングスクール「CodeCamp」で再度学習。この時ウェブ制作に興味を持つ。',
      },
      {
        name: "CSS",
        years: "6",
        value: "3",
        judge: false,
        src: require("@/assets/img/lang/CSS.png"),
        detail: 'HTML同様授業で軽く触れ、CodeCampで再度学習。HTMLと比べCSSは様々な属性があり日々学習中。基本的な項目は問題ないがアニメーションなどに未だ弱い。',
      },
      {
        name: "JavaScript",
        years: "4",
        value: "3",
        judge: false,
        src: require("@/assets/img/lang/JS.png"),
        detail: 'バニラJSでの経験はあまりないが、フレームワーク、特にjQueryで作品を作ってきたので慣れている。バニラJSではタイマーやカウントダウン、簡単なブラウザゲームなどを作成したことがある',
      },
      {
        name: "Java",
        years: "3",
        value: "2",
        judge: false,
        src: require("@/assets/img/lang/Java.png"),
        detail: '大学の授業を中心に学習。オブジェクト指向の学習のために用いた。Javaを用いてclassなどの概念を習得。またカレンダーなどのアプリ、androidアプリなどの作成経験有。また3Dゲームなどを本格的に取り組みインベーダーやRPGゲームの作成経験有。',
      },
      {
        name: "C++",
        years: "3",
        value: "2",
        judge: false,
        src: require("@/assets/img/lang/C++.png"),
        detail: '書き方がJavaに似ていると友人から聞き学習。C++は大した作品の作成経験はない。神経衰弱など実装が簡単なゲームのみ作成経験有。',
      },
      {
        name: "php",
        years: "1",
        value: "1",
        judge: false,
        src: require("@/assets/img/lang/PHP.png"),
        detail: '初歩中の初歩を学習済。疑似ECサイトや自販機を模したウェブサイトを作成経験有。CodeCampでの学習をきっかけに習得。それ以降触れていないのであまり自信はない。',
      },
      // {
      //     name: '',
      //     years: '',
      //     value: '',
      //     judge: false,
      //     src: require("@/assets/img/JS.png"),
      //     detail: '編集中 順次追加予定'
      // },
    ],
  }),
};
</script>

<style>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.no-wrap {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>